import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointContext, useIsMobileContext } from "../contexts";
import { DesktopDoubleOnlyImageNewsCard, DesktopDoubleWithTextNewsCard, DesktopSingleOnlyImageNewsCard, DesktopSingleWithTextNewsCard, MobileLargeOnlyImageNewsCard, MobileLargeWithTextNewsCard, MobileSmallWithTextNewsCard } from "./commonCards";
export function DynamicNewsCard(props) {
    var data = props.data, index = props.index, isOnLanding = props.isOnLanding, isFootballSchoolNewsArticle = props.isFootballSchoolNewsArticle;
    var isMobile = useIsMobileContext();
    var breakpoint = useBreakpointContext();
    if (isMobile) {
        if (isOnLanding) {
            if (index === 0) {
                return _jsx(MobileLargeWithTextNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            }
            else {
                return _jsx(MobileSmallWithTextNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            }
        }
        else {
            if ((index + 1) % 5 == 0) {
                return _jsx(MobileLargeOnlyImageNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            }
            else {
                return _jsx(MobileLargeWithTextNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            }
        }
    }
    else {
        if (isOnLanding) {
            if (breakpoint === "xl") {
                if (index === 0)
                    return _jsx(DesktopDoubleWithTextNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
                if (index === 1)
                    return _jsx(DesktopDoubleOnlyImageNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            }
            else {
                if (index === 0)
                    return _jsx(DesktopDoubleWithTextNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            }
            if (index === 4)
                return _jsx(DesktopSingleWithTextNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            return _jsx(DesktopSingleOnlyImageNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
        }
        else {
            if (breakpoint === "xl") {
                if (index < 2)
                    return _jsx(DesktopDoubleOnlyImageNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
                if (index < 6)
                    return _jsx(DesktopSingleWithTextNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
                if ((index + 4) % 10 < 2)
                    return _jsx(DesktopDoubleOnlyImageNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            }
            else {
                if (index % 5 < 1)
                    return _jsx(DesktopDoubleOnlyImageNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
            }
            return _jsx(DesktopSingleWithTextNewsCard, { data: data, isFootballSchoolNewsArticle: isFootballSchoolNewsArticle });
        }
    }
}
